/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";

import { connect } from "react-redux";
import { loginUser, loadUser } from "../../actions/AuthActions";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function SuperAdmin({ userType, loginUser, auths, loadUser }) {
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  React.useEffect(async () => {
    if (auths.token) {
      const data = await loadUser();
      if (data.success) {
        navigate("/dashboard/tasks");
      }
    }
  }, []);
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const user = {
            email_address: values.email,
            password: values.password,
            type: "super_admin",
          };
          const login = await loginUser(user);
          if (!login.success) {
            setErr(login.message);
          } else {
            navigate("/dashboard/tasks");
          }
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={3} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {err ? (
            <Alert mt={2} mb={3} severity="error">
              {err}
            </Alert>
          ) : null}

          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <TextField
            type="password"
            name="password"
            data-testid="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Signing In &nbsp;
                <CircularProgress size={20} color="primary" />
              </>
            ) : (
              "Sign in"
            )}
          </Button>
          <Button
            component={Link}
            to="/reset-password?user=super_admin"
            fullWidth
            color="primary"
          >
            Forgot password
          </Button>
        </form>
      )}
    </Formik>
  );
}

SuperAdmin.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auths: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { loginUser, loadUser })(SuperAdmin);
